<template>
    <div class="friends_dropdown" >
        <div class="select_friend_container">
            <span class="select_color"></span>
            <div class="my_ref_label">{{ $t('modules.refs.formStep3.friendsDropdownBaseRef') }}</div>
        </div>
        <div class="select_friend_container">
            <span class="select_color first_color"></span>
            <div class="select">
                <select v-model="selectedFriend1" @change="firstFriendChange">
                    <option :value="null">{{ $t('modules.refs.formStep3.friendsNoValSelected') }}</option>
                    <option v-for="(friendRef) in sightRefFriends" :value="friendRef" :key="friendRef.id" >
                        {{ friendRef.friend_username }}
                    </option>
                </select>
            </div>
        </div>

        <div class="select_friend_container">
            <span class="select_color second_color"></span>
            <div class="select">
                <select v-model="selectedFriend2" @change="secondFriendChange">
                    <option :value="null">{{ $t('modules.refs.formStep3.friendsNoValSelected') }}</option>
                    <option v-for="(friendRef) in sightRefFriends" :value="friendRef" :key="friendRef.id" >
                        {{ friendRef.friend_username }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'FriendsDropdown',
    props: ['sightRefFriends'],
    components: {

    },
    data(){
        return {
            selectedFriend1: null,
            selectedFriend2: null
        }
    },
    computed: {

    },
    methods: {
        firstFriendChange(){
            this.$emit("firstFriendChange", this.selectedFriend1)
        },
        secondFriendChange(){
            this.$emit("secondFriendChange", this.selectedFriend2)
        }
    }
}
</script>

<style lang="scss" >
.friends_dropdown{
        display: flex;
        justify-content: center;
        align-items: center;
        .select_friend_container{
            display: flex;
            align-items: center;
            margin: 0 12px;
            .select_color{
                display: block;
                height: 20px;
                width: 20px;
                background-color: $primary;
                border-radius: 100%;
                margin-right: 8px;
                &.first_color{
                    background-color: $second-score-color;
                }
                &.second_color{
                    background-color: $third-score-color;
                }
            }
            select, select:focus{
              border: none;
              box-shadow: none;
            }
        }
    }
</style>